module.exports = __webpack_public_path__ + "bg-banner.b6d7b95f33e1298d6a98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/popular/img/bg-banner.jpg
// module id = ./src/assets/popular/img/bg-banner.jpg
// module chunks = 3